/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { getEditDetailsRouteFor } from 'uplisting-frontend/utils/rhs/routes';

interface IArgs {
  booking: ModelRegistry['booking'];
  hideNavLinks?: boolean;
}

export interface BookingGuestCardSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingGuestCardComponent extends Component<BookingGuestCardSignature> {
  @service router!: Services['router'];
  @service session!: Services['session'];

  dateFormat = 'EEE, MMM do';

  @cached
  get booking(): ModelRegistry['booking'] {
    return this.args.booking;
  }

  @cached
  get canPriceBeFormatted(): boolean {
    return typeof this.price === 'number';
  }

  @cached
  get price(): number | null | undefined {
    const { price } = this.booking;

    if (!price) {
      return;
    }

    return price.occasionPrice;
  }

  @cached
  get editDetailsRoute(): string {
    return getEditDetailsRouteFor(this.router.currentRouteName ?? '');
  }

  get hideNavLinks(): boolean {
    return this.args.hideNavLinks ?? false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Guest::Card': typeof UiBookingGuestCardComponent;
  }
}
